module.exports = __webpack_public_path__ + "static/media/generic_logo1.799ce9bf.png";